import {Component, Input, Type} from '@angular/core';
import {ModalWindowsTypes} from 'src/app/core/enums';
import {IGetClass, IModalWindow} from 'src/app/utils/interfaces/modal-dialog.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'asg-document-opened-dialog',
    templateUrl: './document-opened-dialog.component.html',
    styleUrls: ['./document-opened-dialog.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class DocumentOpenedDialogComponent implements IModalWindow {
  @Input() ok: () => void;
  @Input() no: () => void;

  getWindowType(): Type<IModalWindow> {
    return DocumentOpenedDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.DOCUMENT_OPENED_WINDOW;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | null {
    switch (type) {
        case 'IModalWindow':
          return this as unknown as IModalWindow;
        case 'IGetClass':
          return this as unknown as IGetClass;
        default: return null;
    }
  }

  getClass(): string {
    return 'document-open-dlg';
  }
}
